<template>
  <div>
    <div class="mt-4 flex flex-row items-center">
      <div v-if="isSubSubCategory">
        <a @click="goBack()">
          <svg
            :class="[
              'fill-current inline-block h-8 w-8 mr-2',
              'text-' + theme.body.primaryColor,
            ]"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              class="heroicon-ui"
              d="M5.41 11H21a1 1 0 0 1 0 2H5.41l5.3 5.3a1 1 0 0 1-1.42 1.4l-7-7a1 1 0 0 1 0-1.4l7-7a1 1 0 0 1 1.42 1.4L5.4 11z"
            />
          </svg>
        </a>
      </div>
      <div
        :class="[
          'flex w-1/2 lg:w-2/3 justify-begin text-3xl flex-col',
          theme.body.textColor,
        ]"
      >
        <div v-trans:name="selectedMenuCategory"></div>
        <div class="text-xs" v-trans:description="selectedMenuCategory"></div>
      </div>
      <div class="flex w-1/2 lg:w-1/3 justify-end items-center">
        <Language /><DisplayMode class="ml-2" />
      </div>
    </div>
    <div :class="[isListDisplayed ? 'w-full pb-24' : 'flex flex-wrap']">
      <div
        :class="[
          isListDisplayed ? 'w-full mx-auto mt-4 rounded-large' : 'w-1/2 mt-4',
        ]"
        v-for="(item, index) in menuItems"
        :key="item.Id"
        @click="
          item.hasSubItems == true
            ? $router.push(
                '/' +
                  $route.params.menuHash +
                  '/sub/category/' +
                  $route.params.categoryId +
                  '/menuItemId/' +
                  item.Id
              )
            : '#'
        "
      >
        <div>
          <div :class="[isListDisplayed ? 'w-full' : 'w-1/2']">
            <!--Image-->
            <div></div>
            <!--Title-->
            <div></div>
            <!--Price-->
            <div></div>
            <!--Add Buttons (+,-,default)-->
            <div></div>
          </div>

          <ul
            @click.stop="addToCart(item)"
            :class="[
              'flex flex-col',
              isListDisplayed ? '' : index % 2 == 0 ? 'mr-2' : 'ml-2',
            ]"
          >
            <li class="flex flex-row">
              <div
                :class="[
                  'select-none',
                  'cursor-pointer rounded-md flex flex-1 items-center ',
                ]"
              >
                <div
                  :class="[
                    'w-full flex rounded-lg p-2 relative shadow-lg transition duration-500 hover:shadow-xl',
                    theme.addToCart.backgroundColor,
                    isListDisplayed
                      ? 'md:flex-row lg:flex-row xl:flex-row '
                      : 'flex-col',
                  ]"
                >
                  <div
                    :class="[
                      'flex  items-center',
                      isListDisplayed ? 'flex-row w-3/4' : 'flex-col w-full',
                    ]"
                  >
                    <div
                      :class="[
                        'flex-none flex items-center overflow-hidden rounded-md',
                        item.pictureUrl ? 'block' : 'hidden',
                        isListDisplayed ? 'w-24 h-24' : 'h-24 w-full',
                      ]"
                    >
                      <!--IMG-->
                      <img
                        v-if="item.pictureUrl"
                        :src="item.pictureUrl"
                        alt
                        :class="[
                          'object-cover rounded-lg',
                          isListDisplayed ? 'h-full' : 'w-full',
                        ]"
                      />
                    </div>
                    <div
                      :class="[
                        'flex-grow',
                        'text-' + theme.body.primaryColor,
                        isListDisplayed ? 'ml-4' : '',
                      ]"
                    >
                      <div class="flex-1">
                        <div
                          :class="[
                            'font-medium justify-between',
                            theme.body.textColor,
                          ]"
                        >
                          <span
                            :class="[
                              theme.body.text,
                              ,
                              isListDisplayed ? '' : 'flex justify-center',
                            ]"
                            v-trans:name="item"
                          ></span>
                        </div>
                        <div
                          :class="[
                            'text-sm flex',
                            isListDisplayed ? '' : 'flex justify-center',
                            theme.body.textColor,
                          ]"
                          v-trans:description="item"
                        ></div>
                        <div
                          :class="[
                            'flex flex-wrap mt-2',
                            isListDisplayed ? '' : 'justify-center',
                          ]"
                        >
                          <!--source icons: https://www.flaticon.com/packs/allergenic-food-color?word=allergy-->
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.hasGluten"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/gluten.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["gluten"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.hasEgg"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/egg.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["egg"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.hasFish"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/fish.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["fish"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.hasLactose"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/lactose.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["milk"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.hasMeat"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/meat.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["meat"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.hasNuts"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/almond.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["almond"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.hasPeanuts"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/peanut.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["peanut"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.hasSoya"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/soy.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["soy"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.hasSoya"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/sugarfree.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["sugar_free"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.isVegan"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/vegan.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["vegan"][language] }}
                            </p>
                          </div>
                          <div
                            class="flex flex-col items-center mx-1"
                            v-if="item.isVegetarian"
                          >
                            <img
                              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
                              alt="Nuts"
                              :src="
                                require('../assets/images/allergenes/vegetarian.svg')
                              "
                            />
                            <p
                              :class="[
                                'justify-center flex text-2xs',
                                theme.body.textColor,
                              ]"
                            >
                              {{ lang["vegetarian"][language] }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      orderingEnabled &&
                      selectedMenuCategory.is_ordering_disabled == false
                    "
                    :class="[
                      'flex items-center mt-2',
                      isListDisplayed ? 'flex-col w-1/4' : 'flex-row',
                    ]"
                  >
                    <div
                      v-if="$_.countBy(cartItems, item).true || 0"
                      :class="[
                        'flex items-center rounded-full',
                        theme.addToCart.backgroundColorPlus,
                      ]"
                    >
                      <div
                        class="flex flex-row h-8 rounded-lg relative bg-transparent justify-center items-center"
                        v-if="
                          orderingEnabled &&
                          selectedMenuCategory.is_ordering_disabled == false
                        "
                      >
                        <button
                          @click.stop="removeFromCart(item)"
                          :class="[
                            'fill-current focus:outline-none inline-block h-6 w-6 rounded-full m-2',
                            theme.addToCart.textColorPlus,
                          ]"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M20 12H4"
                            />
                          </svg>
                        </button>
                        <div
                          v-if="itemBeingAdded == item.Id"
                          :class="[
                            theme.body.backgroundColor,
                            'spinner-white w-8',
                          ]"
                          style="position: relative !important"
                        ></div>
                        <input
                          v-else
                          type="number"
                          readonly
                          :class="[
                            theme.body.backgroundColor,
                            theme.body.textColor,
                            'focus:outline-none text-center h-8 w-6 text-md md:text-basecursor-default flex items-center outline-none w-full justify-center',
                          ]"
                          name="custom-input-number"
                          :value="$_.countBy(cartItems, item).true || 0"
                        />
                        <button
                          @click.stop="addToCart(item)"
                          :class="[
                            theme.addToCart.backgroundColorPlus,
                            theme.body.textColorPlus,
                            'h-6 w-6 rounded-full cursor-pointer focus:outline-none m-2',
                            theme.addToCart.textColorPlus,
                          ]"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div
                      v-else
                      :class="['md:items-center w-full justify-center']"
                      @click.stop="addToCart(item)"
                    >
                      <div
                        v-if="
                          orderingEnabled &&
                          selectedMenuCategory.is_ordering_disabled == false
                        "
                        :class="[
                          'rounded-md text-center p-1 rounded-full h-8 flex items-center justify-center shadow-lg transition duration-500  hover:shadow-xl',
                          theme.addToCart.addToCartButtonBackgroundColor,
                          theme.addToCart.addToCartButtonTextColor,
                        ]"
                      >
                        <p class="text-xs px-2">
                          + {{ lang["add_to_cart"][language] }}
                        </p>
                      </div>
                    </div>

                    <span
                      :class="[
                        theme.body.textColor,
                        'mt-3',
                        isListDisplayed ? '' : 'flex justify-end w-1/2 text-sm',
                      ]"
                      v-if="item.price > 0"
                      >{{ currency
                      }}{{
                        (Math.round(item.price * 100) / 100).toFixed(2)
                      }}</span
                    >
                  </div>
                  <div v-else class="flex items-center justify-center">
                    <span
                      :class="[
                        '',
                        isListDisplayed ? '' : 'flex justify-end text-sm',
                      ]"
                      v-if="item.price > 0"
                      >{{ currency
                      }}{{
                        (Math.round(item.price * 100) / 100).toFixed(2)
                      }}</span
                    >
                  </div>
                  <!-- <div
                  v-if="$_.countBy(cartItems, item).true || 0"
                  class="flex absolute"
                  style="right: 0"
                >
                  <div>
                    <p @click="removeItemsFromCart(item)">
                      <svg
                        class="fill-current inline-block h-6 w-6 text-white rounded-full mb-2 mr-2 p-1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </p>
                  </div>
                </div> -->
                </div>

                <div
                  :class="['text-gray-600 text-xs']"
                  v-if="$route.name == 'Home'"
                ></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <modal
        name="item-modifiers"
        width="90%"
        height="auto"
        :maxWidth="480"
        :adaptive="true"
        scrollable
      >
        <div
          :class="[
            'flex flex-col h-full overflow-y-auto pb-8 rounded-large',
            theme.body.backgroundColor,
          ]"
        >
          <div>
            <div class="px-6 py-3 flex border-b">
              <div
                :class="['text-md font-bold flex-grow', theme.body.textColor]"
              >
                {{ lang["modifiers_for"][language] }} "{{
                  currentItem[`name_${language}`]
                }}"
              </div>

              <a @click="$modal.hide('item-modifiers')">
                <svg
                  :class="[
                    'fill-current inline-block h-6 w-6 rounded-full cursor-pointer',
                    theme.addToCart.deleteButtonTextColor,
                  ]"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </a>
            </div>
            <div
              class="px-6"
              v-for="(modifier, index) in modifiers"
              :key="modifier.AdditionGroupId"
            >
              <additions :modifier="modifier" :key="index" />
            </div>
          </div>
          <div class="px-6 py-4 flex justify-end">
            <button
              @click="$modal.hide('item-modifiers')"
              class="text-sm rounded-large text-gray-500 px-2 py-1 mr-2 h-8 shadow-lg transition duration-500 hover:shadow-xl"
            >
              {{ lang["cancel"][language] }}
            </button>
            <button
              :disabled="disableAddToCartButton"
              @click="addToCartWithModifiers()"
              :class="[
                'rounded-large',
                theme.addToCart.addToCartButtonBackgroundColor,
                theme.addToCart.addToCartButtonTextColor,
                this.disableAddToCartButton ? 'bg-primary-light' : '',
                'shadow-lg transition duration-500  hover:shadow-xl text-sm rounded px-2 py-1 h-8'
              ]"
            >
              {{ lang["add_to_cart"][language] }}
            </button>
          </div>
        </div>
        <!-- </div> -->
      </modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Additions from "../components/Additions";
import lang from "../lang";
import Language from "../views/Language";
import DisplayMode from "../views/DisplayMode";
// import Allergenes from "../views/Allergenes";
export default {
  data() {
    return {
      lang: lang,
      currentItem: {},
      itemBeingAdded: "",
      modifiers: [],
      accumulativeAdditions: [],
      selectedModifiers: [],
      modifiersMessage: "",
      disableAddToCartButton: false,
    };
  },
  computed: {
    ...mapGetters([
      "menuItems",
      "theme",
      "currency",
      "orderingEnabled",
      "selectedMenuCategory",
      "isListDisplayed",
      "isSubSubCategory",
      "menuCategory",
      "parentSelectedMenuCategory",
    ]),
    ...mapGetters("Cart", ["cartItems"]),
    ...mapGetters(["language", "menuSubCategories"]),
  },
  name: "Home",
  components: { Additions, DisplayMode, Language },
  methods: {
    goBack() {
      this.$store.commit(
        "updateSelectedMenuCategory",
        this.parentSelectedMenuCategory
      );
      this.$router.back();
    },
    addToCart(item) {
      if (
        this.orderingEnabled &&
        this.selectedMenuCategory.is_ordering_disabled == false
      ) {
        this.currentItem = item;
        this.$store.commit("updateCategoryId", item.MenuCategoryId);
        this.itemBeingAdded = this.currentItem.Id;
        this.$store
          .dispatch("Cart/GET_MENU_ITEM_ORDERING", this.currentItem.Id)
          .then((response) => {
            this.itemBeingAdded = "";
            if (response.data.Modifiers.length) {
              this.modifiers = response.data.Modifiers;
              /** If Minimum selected amount is mentioned then
               * disable the "Add to Cart" button and show message.
               */
              // if (this.s[0].minSelectedAmount == 1) {
              //   this.disableAddToCartButton = true;
              //   this.modifiersMessage =
              //     "Minimun one modifer needs to be selected.";
              // }
              this.$modal.show("item-modifiers");
            } else {
              // this.$store.commit("Cart/addItem", this.currentItem);
              this.$store.dispatch("Cart/UPDATE_ORDER", {
                operation: "add",
                item: this.currentItem,
              });
            }
          })
          .catch(() => {
            this.itemBeingAdded = "";
          });
      }
    },
    addToCartWithModifiers() {
      /** Deep cloning current item to avoid hoisting. */
      let tempCurrentItem = this.$_.cloneDeep(this.currentItem);
      // let totalAddedPriceOfModifiers = 0;
      if (this.selectedModifiers.length >= 1) {
        tempCurrentItem["OrderItemAdditions"] = [];
        for (let i = 0; i < this.selectedModifiers.length; i++) {
          /** if the Modifier has price attached then add it. */
          // if (this.selectedModifiers[i]["price"]) {
          //   totalAddedPriceOfModifiers += this.selectedModifiers[i]["price"];
          // }
          tempCurrentItem["OrderItemAdditions"].push({
            Addition: this.selectedModifiers[i],
          });
        }
      }
      // this.$store.commit("Cart/addCartAdditions", totalAddedPriceOfModifiers);
      this.$store.dispatch("Cart/UPDATE_ORDER", {
        operation: "add",
        item: tempCurrentItem,
      });
      this.$modal.hide("item-modifiers");
      this.selectedModifiers = [];
      this.accumulativeAdditions = [];
    },
    removeFromCart(item) {
      this.currentItem = item;
      this.itemBeingAdded = this.currentItem.Id;
      this.$store
        .dispatch("Cart/UPDATE_ORDER", { operation: "remove", item: item })
        .then(() => {
          this.itemBeingAdded = "";
        })
        .catch(() => {
          this.itemBeingAdded = "";
        });
    },
    async removeItemsFromCart(item) {
      this.$store.commit("Cart/removeItems", item);
      this.$store.dispatch("Cart/UPDATE_ORDER", {
        operation: "remove",
        item: [],
      });
    },
  },
  created() {
    window.$eventBus.$on("additions-selected", (selectedAddtions) => {
      /**
       * accumulativeAdditions is temporary variable kept just to finalise the final
       * array of additions which going to be posted.
       */
      this.accumulativeAdditions[`Group_${selectedAddtions.modifierGroupId}`] =
        selectedAddtions.selectedModifiers;
      /** Based on accumulativeAdditions, a final array of objects(additions) prepared
       * which will be sent to the server over an xhr request. (Post/Patch order)
       */
      this.selectedModifiers = [];
      for (let i = 0; i < Object.keys(this.accumulativeAdditions).length; i++) {
        Object.values(this.accumulativeAdditions)[i].forEach((element) => {
          this.selectedModifiers.push(element);
        });
      }
    });
    window.$eventBus.$on("add-to-cart-button-disable", (data) => {
      this.disableAddToCartButton = data;
    });
  },
  mounted() {
    this.$store.commit("updateSubCategoryId", this.$route.params.subCategoryId);
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>